var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-config-provider',{attrs:{"locale":_vm.locale,"auto-insert-space-in-button":false}},[_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }